/**
 * An interceptor-free axios instance used ONLY by POST /login/refresh/.
 *
 * It must stay interceptor-free: a 401 here is terminal, and routing it back
 * through the main client's 401 handler would recurse. It is also excluded
 * from the gateway-error toast, because a failure here already ends in
 * logout and a second message adds nothing.
 */

import axios from "axios";

import ENDPOINTS from "./endpoints";
import { API_BASE_URL, API_KEY } from "./env";

const REFRESH_CLIENT = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(API_KEY ? { "x-api-key": API_KEY } : {}),
  },
});

/**
 * @param {string} refreshToken
 * @returns {Promise<{authToken: string, refreshToken: string}|null>}
 */
export const requestTokenRefresh = async (refreshToken) => {
  const response = await REFRESH_CLIENT.post(ENDPOINTS.AUTH.refresh, {
    refreshToken,
  });

  const tokens = response?.data;

  return tokens?.authToken ? tokens : null;
};

export default REFRESH_CLIENT;
